export const publicNavbar = [
  { name: "Ceník", path: "/cenik" },
  { name: "Podpora", path: "/podpora" },
  { name: "Blog", path: "/blog" },
  { name: "O nás", path: "/kontakt" },
];
